import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Icon, Grid, Menu, Container, Divider, Header, Card, Table, Label, Dropdown, List} from 'semantic-ui-react';
import { CardComposer } from '../cards/CardComposer';
import { CardSong } from '../cards/CardSong';
import { EditSongCycleVersion } from './EditSongCycleVersion';
import { useAuth0 } from '@auth0/auth0-react';
import RoleWrapper from "../common/RoleWrapper";
import { DeleteSongCycle } from './deletes/DeleteSongCycle';

export const ViewSongCycle = () => {
  const [ data, setData ] = useState();
  const [ title, setTitle ] = useState('');
  const [ composer, setComposer ] = useState({ profile: {} });
  const [ displayVersion, setDisplayVersion ] = useState({});
  const [ versionBar, setVersionBar ] = useState();
  const { id } = useParams();
  const [ info, setInfo ] = useState();
  const [ songVersions, setSongVersions ] = useState();
  const [ allSongs, setAllSongs ] = useState([]); // all songs by composer, for edit dialogs
  const { isAuthenticated, getIdTokenClaims } = useAuth0();
  const [roles, setRoles] = useState([]); // for role identification
  const namespace = "http://myapp.com"; // for the role selection
  
  const infoProps = [
    'alternate_title',
    'commission',
    'composition_end_date',
    'composition_start_date',
    'created_at',
    'dedication',
    'id',
    'notes',
    'premiere_date',
    'song_cycle_id',
    'title',
    'version_name'
  ];

  function onVersionEdit(version) {
    console.log("on version edit", version);
  }

  useEffect(() => {
    const fetchRoles = async () => {
      if (isAuthenticated) {
        const claims = await getIdTokenClaims();
        setRoles(claims[namespace + "//roles"] || []);
      }
    };
    fetchRoles();
  }, [isAuthenticated, getIdTokenClaims]);

  useEffect(() => {
    async function getData() {
      const result = await fetch(`/go/api/v1/song-cycles/search/${id}`);
      const json = await result.json();
      if (!json.hits.hits.length) {
        return;
      }
      const src = json.hits.hits[0]._source;

      console.debug("initial result", src);
      setData(src);
      const cycle = src.song_cycle;
      setComposer({ profile: src.composer });

      const origversion = src.versions.filter((version) => version.song_cycle_version.version_name === "Original");

      if (origversion.length === 1) {
        setDisplayVersion(origversion[0]);
        setTitle(origversion[0].song_cycle_version.title);
      } else if (src.versions.length > 0) {
        setDisplayVersion(src.versions[0]);
        setTitle(src.versions[0].song_cycle_version.title);
      } else {
        console.log("no versions found");
      }

      const allResult = await fetch(`/go/api/v1/songs/search?q=composer_id:${src.composer_id}`);
      const allJson = await allResult.json();
      if (!allJson.hits.hits.length) {
        return;
      }
      const songs = allJson.hits.hits.map(hit => hit._source);
      setAllSongs(songs);
    }

    getData();
  }, []);

  useEffect(() => {
    if (!data || Object.keys(displayVersion).length === 0) return;

    const rows = infoProps.map((p, i) => {
      if (!displayVersion.song_cycle_version[p]) {
        return (<div key={i}/>);
      }
      const k = p.replace(/(\W|_)+/g, ' ');
      return (
        <Grid.Row key={i}>
          <Grid.Column width={3} className='text-align-right'><strong className='text-capitalize'>{k}</strong></Grid.Column>
          <Grid.Column width={10}>{displayVersion.song_cycle_version[p]}</Grid.Column>
        </Grid.Row>
      );
    });
    setInfo(
      <div>
        <Header as='h3' color='yellow' className='subtitle'>Cycle Data</Header>
        <Grid>
          {rows}
        </Grid>
      </div>
    );

    const songEntries = displayVersion.song_versions.map((v, i) => {
      return (        
        <List.Item key={i}>
          <List.Content verticalAlign='middle'>
            <Card
              color='green'
              header={v.title}
              meta={`Version: ${v.version_name}`}
              href={`../songs/${v.song_id}`}
            />
          </List.Content>
        </List.Item>
      );
    });
    setSongVersions(
      <div>
        <Header as='h3' color='green' className='subtitle'>Songs comprised</Header>
        <Grid>
          <Grid.Column width={1}/>
          <Grid.Column width={10}>
            <List ordered>
              {songEntries}
            </List>
          </Grid.Column>
        </Grid>
        
      </div>
    );

    const editButton = (
      <Button basic icon labelPosition="left">
        <Icon name="edit"/>
        Edit
      </Button>
    );
  
    const cloneButton = (
      <Button basic icon labelPosition="left">
        <Icon name="copy"/>
        New from current
      </Button>
    );
  
    const newButton = (
      <Button basic icon labelPosition="left">
        <Icon name="add"/>
        New
      </Button>
    );
    
    const deleteButton = (
      <Button basic icon labelPosition="left">
        <Icon name="trash alternate"/>
        Delete Song Cycle
      </Button>
    );
  
    const ddOptions = data.versions.map((v, i) => {
      return {
        text: v.song_cycle_version.version_name,
        value: i
      };
    });
  
    const dropdown = (
      <Dropdown selection
        options={ddOptions}
        defaultValue={0}
        onChange={(e, val) => {
          e.preventDefault();
          console.log("display change", val);
          setDisplayVersion(data.versions[val.value]);
          setTitle(data.versions[val.value].song_cycle_version.title);
        }}
      />
    );

    const editModal = (
      <EditSongCycleVersion songOptions={allSongs} openButton={editButton} onSuccess={onVersionEdit} version={displayVersion} cycleId={displayVersion.song_cycle_version.song_cycle_id} />
    );

    // const cloneModal = (
    //   <EditSongCycleVersion songOptions={allSongs} openButton={cloneButton} onSuccess={onVersionEdit} version={displayVersion} cloning={false} cycleId={displayVersion.song_cycle_version.song_cycle_id}/>
    // );
  
    const newModal = (
      <EditSongCycleVersion songOptions={allSongs} openButton={newButton} onSuccess={onVersionEdit} cycleId={displayVersion.song_cycle_version.song_cycle_id}/>
    );

    const deleteModal = (
      <DeleteSongCycle  songOptions={allSongs} openButton={deleteButton} onSuccess={onVersionEdit} version={displayVersion} cycleId={displayVersion.song_cycle_version.song_cycle_id} />
    );

    const modalButtons = (
      <RoleWrapper roles={roles} requiredRole="Editor">
        <Dropdown
          text="Edit Actions"
          icon="dropdown"
          button
          className="primary"
        >
          <Dropdown.Menu>
            <Dropdown.Item>
              {editModal}
            </Dropdown.Item>

            <Dropdown.Item>
              {newModal}
            </Dropdown.Item>

            <Dropdown.Item>
              {deleteModal}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </RoleWrapper>
    );


    //const modalButtons = isAuthenticated ? (
      //<span>
        //{editModal} {/*cloneModal*/} {newModal}
      //</span>
    //) : null;

    setVersionBar(
      <div className='song-version-bar'>
        <span>Version: {dropdown}</span> 
        <span>{modalButtons}</span>
      </div>
    );

  }, [displayVersion, allSongs]);

  if (!data) return (
    <div></div>
  );

  return (
    <Container className='view-container'>
      <Grid>
        <Grid.Column width={3}>
          <Header as='h3' color='blue' className='subtitle'>Composer</Header>
          <CardComposer data={composer} id={data.composer_id} />
          {/* <Header as='h3' color='blue' className='subtitle'>Text Author(s)</Header> */}
        </Grid.Column>
        <Grid.Column width={13}>
          <Header as='h3' color='yellow' className='subtitle'>Song Cycle</Header>
          <Header as='h1' className='title' size='huge'>{title}</Header>
          {versionBar}
          <div className='meta'>
            {displayVersion.title}
          </div>
          <Divider hidden />
          {songVersions}
          <Divider hidden />
          {/* {info} */}
        </Grid.Column>
      </Grid>
    </Container>
  );
};
